import {Currency} from '../reusables/currency';
import {Status} from '../reusables/status';
import {
  TicketingAdditionalItems,
  TicketingAffiliate,
  TicketingDeliveryAddress,
  TicketingEvents,
  TicketingOrderDetails,
  TicketingReservationDetails,
  TicketingSalesChannel,
  TicketingSalesOperator,
  TicketingStandardAddress,
} from './ticketing-objects';
import {InvoiceOrderStatusTranslationsService} from 'src/app/shared/translations';
import {DateObject} from '../reusables/date-object';

/**
 * Blueprint for the customer status object.
 */
export class ReservationTicket {
  public id: number;
  public cancellationAddress: string;
  public type: string;
  public additionalItems: TicketingAdditionalItems;
  public affiliate: TicketingAffiliate;
  public deliveryAddress: TicketingDeliveryAddress;
  public events: Array<TicketingEvents>;
  public orderDetails: TicketingOrderDetails;
  public reservationDetails: TicketingReservationDetails;
  public saleOperator: TicketingSalesOperator;
  public salesChannel: TicketingSalesChannel;
  public standardAddress: TicketingStandardAddress;
  public invoiceState: Status;

  public statuses: Array<any> = [
    {value: 'booked', status: this.translations.i18nBooked, class: 'esf-tag--success'},
    {value: 'bookable', status: this.translations.i18nBookable, class: 'esf-tag--info'},
    {value: 'expired', status: this.translations.i18nExpired, class: 'esf-tag--alert'}
  ];

  constructor(data?: any, private translations?: InvoiceOrderStatusTranslationsService) {
    this.id = data.id;
    this.type = data.type;
    this.affiliate = new TicketingAffiliate(data.affiliate);
    this.deliveryAddress = data.deliveryAddress ? new TicketingDeliveryAddress(data.deliveryAddress) : null;
    this.orderDetails = new TicketingOrderDetails(data.orderDetails, translations);
    this.saleOperator = new TicketingSalesOperator(data.saleOperator);
    this.salesChannel = new TicketingSalesChannel(data.salesChannel, translations);
    this.standardAddress = data.standardAddress ? new TicketingStandardAddress(data.standardAddress) : null;
    this.reservationDetails = new TicketingReservationDetails(data.reservationDetails);
    this.invoiceState = new Status(this.getFullStatus(data.invoiceState ?? 'bookable'));

    this.events = [];
    data.events.forEach(event => {
      this.events.push(new TicketingEvents(event));
    });

  }

  /**
   * Retrieves the status
   */
  public getFullStatus(status: string): any {
    const fullStatus = this.statuses.find(possibleStatuses => status === possibleStatuses.value);
    return fullStatus ? fullStatus : {};
  }

  get date(): DateObject {
    return this.orderDetails.invoiceDate;
  }

  get reservationNumber(): string {
    return this.reservationDetails.reservationId;
  }

  get totalAmount(): Currency {
    return this.orderDetails.paymentDetails;
  }

  get translatedType(): string | string {
    return this.translations.i18nReservation;
  }
}
